import { createFileRoute } from '@tanstack/react-router';

import { PortfolioPage } from '@/features/portfolio/PortfolioPage';
import { isMarket, type Market } from '@/lib/market/types';

/**
 * `/:market/portfolio` —— 庫存股（features/portfolio/PortfolioPage.tsx）。
 * 市場分頁與 `?as_of` 跟自選股一致：`?as_of` 在 `__root.tsx` 宣告，這裡繼承。
 */
export const Route = createFileRoute('/$market/portfolio')({
  component: PortfolioRoute,
});

function PortfolioRoute() {
  const { market: rawMarket } = Route.useParams();
  const market: Market = isMarket(rawMarket) ? rawMarket : 'tw';
  return <PortfolioPage market={market} />;
}
